// extracted by mini-css-extract-plugin
export default {"container":"list-module__container--34nWl","key":"list-module__key--FD_Dg","value":"list-module__value--3i2c9"};